<template>
	<div
		v-if="isBlockShown"
		id="programm_announces"
		:class="
			'panel programms ' +
				(block.hide_top_indent ? ' mt-0 pt-0 ' : '') +
				(block.hide_bottom_indent ? ' mb-0 pb-0 ' : '') +
				block.appearance
		"
	>
		<div>
			<div class="container">
				<div class="panel_header">
					<PanelThemesHeader
						:title="block.block_title"
						:prop-active-tab="TABS_ID.EVENTS"
						@updateRecommendationsData="handleRecommendationsData"
					>
						<template #link-button>
							<ArrowButton url="/navigator/events/" class="d-none d-lg-block">
								Все мероприятия
							</ArrowButton>
							<span class="d-flex d-lg-none title mb-0 icon-chevron-thin-right" />
						</template>
					</PanelThemesHeader>
				</div>
				
				<ListWithMobileSlider
					desktop-class="programms_list row d-none d-md-flex"
					desktop-list-class="col-12 col-md-6 col-xl-4"
					mobile-class="row d-flex d-md-none"
					:items-list="getDynamicDataWithTags(content)"
				>
					<template #default="{ item }">
						<EventCard
							v-if="item"
							:event="item"
							:block="block"
							:is-alumni="isAlumni"
							:image="
								item.top_cover_image_url_wide ||
									item.top_cover_image_default?.src
							"
						/>
					</template>
				</ListWithMobileSlider>

			</div>
		</div>
	</div>
</template>

<script>
import '@/utils/moment';
import { directive } from 'vue-awesome-swiper';
import { mapActions } from 'vuex';
import checkIsBlockShown from '~/mixins/checkIsBlockShown';
import EventCard from '~/components/cards/EventCard.vue';
import ArrowButton from '~/components/buttons/ArrowButton.vue';
import PanelThemesHeader from '~/components/panels/system/PanelThemesHeader.vue';
import recommendationTags from '~/mixins/recommendationTags';
import ListWithMobileSlider from '~/components/ListWithMobileSlider.vue';

export default {
	name: 'PanelDynamicEventsAnnouncesV2',
	components: {
		ListWithMobileSlider,
		PanelThemesHeader,
		ArrowButton,
		EventCard,
	},
	directives: {
		swiper: directive,
	},
	mixins: [checkIsBlockShown, recommendationTags],
	props: {
		block: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			fetchedData: [],
			activeClass: 'active',
			announceActiveButtons: {
				'': true,
			},
			announceButtons: [
				['', 'Все'],
				['0', 'Вебинары'],
				['2', 'Online-конференции'],
				['18', 'Live курс'],
			],
			options: {
				slidesPerView: 'auto',
				spaceBetween: 0,
				// freeMode: true,
				loop: false,
			},
		};
	},
	computed: {
		content() {
			return this.block.events;
		},
	},
	mounted() {
		this.$pagesApi
			.events({ per_page: 5, index_list: true })
			.then((response) => {
				this.fetchedData = response;
			});
	},
	methods: {
		loadAnnounces(type) {
			this.announceActiveButtons = {};
			this.announceActiveButtons[type] = true;
			this.$pagesApi
				.events({ per_page: 5, index_list: true, type })
				.then((response) => {
					this.fetchedData = response;
				});
		},
	},
	...mapActions({
		showLoginPopup: 'authModal/showLogin',
	}),
};
</script>

<style lang="scss" scoped>
@import "~/assets/styles/components/home/panel-announces";

@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

</style>
